import React, { Component } from 'react'
import PropTypes from 'prop-types'
import utils from '../../lib/utils'

export default class Switch extends Component {
  static propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
  }

  onChange = e => {
    const checked = e.target.checked
    this.props.onChange(checked)
  }

  render () {
    const {value} = this.props
    const checked = utils.isChecked(value)

    return <label className='ui-switch'>
      <input type='checkbox' className='rf-Checkbox'
        onChange={this.onChange}
        checked={checked}
      />
      <div />
    </label>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/Switch.js